import { type ReactNode } from 'react'

import { type ModalData } from '../hooks/use-store'
import { type getLink } from './get-link'

type Params = {
  modal: ModalData
  userId: string
}

export const getData = ({ modal, userId }: Params) => {
  let title: ReactNode
  let description: ReactNode
  let subTitle: ReactNode
  const searchParams: Parameters<typeof getLink>[0]['searchParams'] = {}

  switch (modal.type) {
    case 'bill':
      title = 'Оплата по счёту'
      description = 'Выберите мессенджер, чтобы перейти в бот и оформить счёт для оплаты'
      subTitle = 'В боте вы получите счёт и реквизиты'
      searchParams.tariff = String(modal.activeTariffId)
      searchParams.zakaz_id = modal.orderId
      searchParams.evirma_user_id = userId
      break
    case 'support':
      title = 'Связаться с поддержкой'
      description = 'Выберите мессенджер, чтобы перейти в бот технической поддержки'
      subTitle = 'Ответим на вопросы и поможем решить проблему'
      searchParams.user_id_evirma = userId
      break
  }

  return {
    title,
    description,
    subTitle,
    searchParams,
  }
}
